import React from "react" 
import { FiBookmark, FiX } from "react-icons/fi";
 
const tagList2 = [
    {id:1, title:'UI Designer'},
    {id:2, title:'Product Designer'},
    {id:3, title:'Software Engineer'},
] 

export const TagFilter = ({title}) => {

    const [search,setSearch]=React.useState('');

    return (<div className="tags_filter">
        {title && <h4>{title}</h4>}
        <div className="searching">
                <input 
                    name=""
                    placeholder="Tags"
                    value={search}
                    onChange={e=>setSearch(e.target.value)}
                />
               {/**  <FaSearch /> */}
               <FiBookmark />
            </div>

        <ul>
            {
                tagList2.map((item,i)=>{
                    return (
                        <li key={'tag-list-'+i}>
                         <div>
                           <p>{item.title}</p>
                           <div className="icon">
                                <FiX />
                           </div>
                         </div>
                        </li>
                    )
                })
            }
        </ul>
    </div>)

}


